/**
 * The visitor's IANA time zone, e.g. "America/Chicago".
 *
 * Sent with writes that record something a person did, so exports can render
 * the timestamp on their own clock. Returns undefined where the browser cannot
 * report one; callers should treat that as "unknown" and fall back to UTC
 * rather than substituting a guess.
 */
const browserTimeZone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};

export default browserTimeZone;
